import { D3CursorEvent } from '@shared/types/common-graph.types';

export const mapTouchEventToD3CursorEvent = (event: TouchEvent): D3CursorEvent => {
  const touch = event.touches[0] || event.changedTouches[0];
  return {
    clientX: touch.clientX,
    clientY: touch.clientY,
    currentTarget: event.currentTarget,
    pageX: touch.pageX,
    pageY: touch.pageY,
  };
};
